import { Student, StudentConnection } from "@/__generated__/graphql";

export function studentParser(
  studentConnection?: Partial<StudentConnection>,
): Student[] {
  return (
    studentConnection?.edges?.map((edge) => ({
      id: edge?.node?.id ?? "",
      uuid: edge?.node?.uuid ?? "",
      firstName: edge?.node?.firstName ?? "",
      lastName: edge?.node?.lastName ?? "",
      name: edge?.node?.studentOrganizationStatus?.name ?? "",
      profilePhoto: edge?.node?.profilePhoto,
    })) ?? []
  );
}
